import { Skeleton } from "components/Skeleton";

export default function CreditNoteDetailSkeleton({
  label = "Loading note details…",
  legacy = false,
  showHeading = true,
}) {
  return (
    <div
      className={`credit-note-detail-skeleton${legacy ? " is-legacy" : ""}`}
      role="status"
      aria-busy="true"
      aria-label={label}
    >
      <span className="skeleton-sr-only">{label}</span>
      {showHeading && <header className="credit-note-detail-skeleton__heading">
        <div>
          <Skeleton width={230} height={40} radius={6} />
          <Skeleton width={280} height={20} radius={4} />
        </div>
        <div className="credit-note-detail-skeleton__actions">
          <Skeleton width={120} height={40} radius={10} />
          <Skeleton width={100} height={40} radius={10} />
        </div>
      </header>}

      {legacy && (
        <div className="credit-detail-summary">
          {[0, 1, 2].map((card) => (
            <section className="credit-detail-card credit-note-detail-skeleton__summary" key={card}>
              <Skeleton width="38%" height={12} radius={4} />
              <Skeleton width="58%" height={25} radius={6} />
              <Skeleton width="72%" height={12} radius={4} />
            </section>
          ))}
        </div>
      )}

      <div className={legacy ? "credit-detail-grid" : undefined}>
        <DocumentCardSkeleton />
        {legacy && (
          <aside className="credit-detail-card credit-note-detail-skeleton__aside">
            <Skeleton width="52%" height={22} radius={5} />
            <Skeleton width="88%" height={12} radius={4} />
            <Skeleton width="74%" height={12} radius={4} />
            <Skeleton width="82%" height={12} radius={4} />
            <Skeleton width="64%" height={12} radius={4} />
          </aside>
        )}
      </div>

      <section className="credit-detail-card credit-detail-activity credit-note-detail-skeleton__history">
        <div className="credit-note-detail-skeleton__history-heading">
          <div>
            <Skeleton width={180} height={20} radius={5} />
            <Skeleton width={300} height={12} radius={4} />
          </div>
          <Skeleton width={92} height={40} radius={10} />
        </div>
        {[0, 1].map((row) => (
          <div className="credit-note-detail-skeleton__history-row" key={row}>
            <Skeleton width="24%" height={13} radius={4} />
            <Skeleton width={145} height={12} radius={4} />
            <Skeleton width="18%" height={12} radius={4} />
            <Skeleton width="58%" height={12} radius={4} />
          </div>
        ))}
      </section>
    </div>
  );
}

function DocumentCardSkeleton() {
  return (
    <section className="credit-detail-card credit-detail-document credit-note-detail-skeleton__document">
      <div className="credit-note-detail-skeleton__document-heading">
        <Skeleton width="22%" height={22} radius={5} />
        <Skeleton variant="pill" width={72} height={24} />
      </div>
      <div className="credit-note-detail-skeleton__identity">
        <div>
          <Skeleton width="42%" height={12} radius={4} />
          <Skeleton width="58%" height={16} radius={4} />
          <Skeleton width="72%" height={20} radius={5} />
        </div>
        <div>
          {[0, 1].map((row) => (
            <span key={row}>
              <Skeleton width="28%" height={12} radius={4} />
              <Skeleton width="48%" height={14} radius={4} />
            </span>
          ))}
        </div>
      </div>
      <div className="credit-note-detail-skeleton__table">
        {[0, 1].map((row) => (
          <div key={row}>
            {[0, 1, 2, 3, 4].map((column) => (
              <Skeleton key={column} width={column ? "62%" : "78%"} height={12} radius={4} />
            ))}
          </div>
        ))}
      </div>
      <Skeleton className="credit-note-detail-skeleton__total" width={220} height={22} radius={5} />
      <div className="credit-note-detail-skeleton__balance">
        <Skeleton width={150} height={18} radius={5} />
        <Skeleton width="48%" height={12} radius={4} />
      </div>
    </section>
  );
}
